export const QUEUE_TYPE_DEFAULT = 0;
export const QUEUE_TYPE_PRESCRIPTION_REFILL_REQUEST = 1;
export const QUEUE_TYPE_STANDALONE_CHAT = 2;

export const TIMEOUT_CUSTOMER_MESSAGE = 120000;
export const TIMEOUT_WAITING_AGENT = 300000;
export const TIMEOUT_WAITING_QUEUE_INFO = 60000;
export const TIMEOUT_END_LIVE_CHAT = 1800000; // 30 min
export const TIMEOUT_TYPING_EVENT = 30000;
export const TIMEOUT_SHOW_CHATBOT_MESSAGE = 500;

export const MSG_GET_INTENT_DESCRIPTION = 'GET_INTENT_DESCRIPTION';
export const MSG_START_CHAT = 'START_CHAT';
export const MSG_WAITING_AGENT = 'WAITING_AGENT';
export const MSG_LEX_BOT_ENTER_CHAT = 'LEX_BOT_ENTER_CHAT';
export const MSG_CANCEL_LIVE_CHAT = 'CANCEL_LIVE_CHAT';

export const DISPLAY_NAME_BOT = 'BOT';
export const DISPLAY_NAME_SYSTEM_MESSAGE = 'SYSTEM_MESSAGE';

export const TYPE_MESSAGE = 'MESSAGE';
export const TYPE_EVENT = 'EVENT';

export const CONTENT_TYPE_CAROUSEL = 'corusel';
export const CONTENT_TYPE_TYPING = 'typing';
export const CONTENT_TYPE_TEXT = 'text/plain';
export const CONTENT_TYPE_PLAIN_TEXT = 'PlainText';
export const CONTENT_TYPE_EVENT = 'EVENT';
export const CONTENT_TYPE_FEEDBACK = 'feedback'
export const CONTENT_TYPE_TRANSFER = 'transfer'

export const CONNECT_EVENT_JOINED = 'application/vnd.amazonaws.connect.event.participant.joined';
export const CONNECT_EVENT_LEFT = 'application/vnd.amazonaws.connect.event.participant.left';
export const CONNECT_EVENT_TRANSFER_SUCCEEDED = 'application/vnd.amazonaws.connect.event.transfer.succeeded';
export const CONNECT_EVENT_TRANSFER_FAILED = 'application/vnd.amazonaws.connect.event.transfer.failed';
export const CONNECT_EVENT_TYPING = 'application/vnd.amazonaws.connect.event.typing';
export const CONNECT_EVENT_CHAT_ENDED = 'application/vnd.amazonaws.connect.event.chat.ended';

export const ROLE_SYSTEM = "SYSTEM";
export const ROLE_AGENT = "AGENT";
export const ROLE_CUSTOMER = "CUSTOMER";

export const LOADER_STATUS_NONE = 0;
export const LOADER_STATUS_LOADING = 1;
export const LOADER_STATUS_LOADED = 2;